
import { DocumentNode } from "graphql"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import { useAppoloStore } from "../../../settings/zustand"
import { GET_ALL_TESTS_ACTION, GET_TEST_ACTION, GET_TEST_RESULTS_USERS_ACTION, GET_TEST_TRY_COUNT_ACTION, GET_TEST_USER_RESULT_ACTION, GET_TEST_USER_RESULTS_ACTION, REMOVE_TEST_RESULT_ACTION, UPDATE_TEST_USER_RESULT_ACTION } from "./actionTypes"
const { gql } = require("@apollo/client/core")

const asyncControllers =  async(action:string, data: any) => {
    let response : any, 
        query : DocumentNode,
        query_name : string, 
        fields : any,
        _query: string = '',
        _mutation: string = ""
        
    const apolloClient: any = useAppoloStore.getState().client
    switch( action )
    { 
        case GET_TEST_ACTION: 
            response = fetch( "/assets/data/tests/tests.json")
                .then(res => res.json() )
                .then(r => { 
                    // -- mock
                    useDataStore.setState({
                        PETest: Object.keys(r).map(key => {
                            return r[key]
                        })
                    })
                    //
                    return ({  data: { getTest: r[ data.id ] }})
                })
            return response   
        case GET_ALL_TESTS_ACTION: 
            response = fetch( "/assets/data/tests/tests.json")
                .then(res => res.json() )
                .then(r => {
                    let items = Object.keys(r).map(key => r[key]) 
                    // -- mock
                    useDataStore.setState({
                        PETest: items
                    })
                    //
                    return ({ data: { getAllTests: items }})
                })
            return response   
        case GET_TEST_TRY_COUNT_ACTION: 
            _query = `query getTestTryCount {
                getTestTryCount(test_id: "${data.test_id}", user_id: "${data.user_id}")  
            }`
            query = gql`${ _query}`
            response = await apolloClient.query({ query })      
            return response    
        case REMOVE_TEST_RESULT_ACTION:   
            _query = `mutation removeTestResult {
                removeTestResult(id: "${data.id}")  
            }`
            _mutation = gql`${ _query}`
            response = await apolloClient.mutate({
                mutation: _mutation,
                variables: data
            })   
            return response   
        case GET_TEST_USER_RESULT_ACTION:   
            _query = `query getTestResult {
                getTestResult(test_id: "${data.test_id}", user_id: "${data.user_id}") {
                    id
                    test_id
                    user {
                        display_name
                        id
                        roles
                    }
                    user_data
                    results
                }
            }`
            query = gql`${ _query}`
            response = await apolloClient.query({ query })      
            return response   
        case GET_TEST_RESULTS_USERS_ACTION:   
            _query = `query getTestResultsUser {
                getTestResultsUser{
                    user {
                        id
                        display_name
                        avatar
                        user_descr
                    }
                }  
            }`
            query = gql`${ _query}`
            response = await apolloClient.query({ query })      
            return response

        case GET_TEST_USER_RESULTS_ACTION: 
            _query = `query getUserTestResults {
                getUserTestResults(user_id: "${ data.user_id }") {
                    test_id
                    ID
                    user {
                        id
                        display_name
                        avatar
                        user_descr
                    }
                    results
                } 
            }` 
            query = gql`${ _query }`
            response = await apolloClient.query({ query })      
            return response  
        case UPDATE_TEST_USER_RESULT_ACTION:   
            _query = `mutation updateTestResult($user_id: ID, $test_id: ID, $results: String, $user_data: String ) {
  updateTestResult( user_id: $user_id, test_id: $test_id, results: $results, user_data: $user_data )  {
    user_id
    test_id
    results
  }
}`
            // console.log( _query, data )
            _mutation = gql`${ _query}`
            response = await apolloClient.mutate({
                mutation: _mutation,
                variables: data
            })      
            return response   
         
        default: 
            return  new Promise<any>( (resolve, reject) => { resolve(`Unknown action type: ${action}`)} )
    }
}
export default asyncControllers